import qs from 'qs';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import { getDocumentById } from '../../services/prismic';
import { ContentTypeRenderer } from '../ContentTypeRenderer';
import styles from '../Page/Page.css';

import type { BloodhoundDocument } from 'src/content-types/union';

export function Preview() {
  const location = useLocation();
  const [document, setDocument] = useState<BloodhoundDocument>();

  useEffect(() => {
    const { documentId } = qs.parse(location.search, {
      ignoreQueryPrefix: true,
    });

    async function getPreviewDocument() {
      if (documentId && typeof documentId === 'string') {
        const previewDocument = (await getDocumentById(
          documentId
        )) as BloodhoundDocument;
        setDocument(previewDocument);
      }
    }

    void getPreviewDocument();
  }, [location]);

  if (!document) {
    return null;
  }

  return (
    <main className={styles.main}>
      <ContentTypeRenderer document={document} />
    </main>
  );
}
